import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormGroup, Validators, FormControl, AbstractControl } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
// import { ItemClassDisplayOrderModel } from './model/system-settings.model';
import { ItemClassDisplayOrderService } from './item-class-display-order.service';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable, of } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { get } from 'jquery';
import { ConfirmDialogService } from 'src/app/common/components/confirm-dialog/confirm-dialog.service';

@Component({
  selector: 'app-item-class-display-order',
  templateUrl: './item-class-display-order.component.html',
  styleUrl: './item-class-display-order.component.scss',
  standalone: false
})
export class ItemClassDisplayOrderComponent implements OnInit,DirtyCheck {

  menuList: any[] = []; // Fill this with your API data
  filteredMenuDepartments: any[] = [];
  itemSubClasses: any;
  itemRows: any[] = [];
  dropLists: string[] = []; // hold connected drop list ids
  menuDepartmentControl: FormControl<string | null>;
  itemClassForm!: FormGroup;
  isFormDirty: boolean = false;
  lastConfirmedMenuId: number | null = null;
  menuId: any;
  numberOfColumns: number = 2 + 1; // Default number of columns, can be changed based on requirements
  menuInitialized: boolean = false;
  menuColor: { name: string; value: string; } | undefined;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private builder: FormBuilder,
    private snackBarService: SnackBarService,
    public dialog: MatDialog,
    private itemClassDisplayOrderService: ItemClassDisplayOrderService,
    private confirmDialogService: ConfirmDialogService
  ) {
    this.itemClassForm = this.builder.group({
      menu_department: this.builder.control('', [Validators.required, this.menuDepartmentValidator]),
      number_of_columns: this.builder.control('')
    });

    this.menuDepartmentControl = this.itemClassForm.get('menu_department') as FormControl;
    this.itemClassForm.valueChanges.subscribe(() => {
      this.isFormDirty = true;
    });

  }

  ngOnInit() {
    this.getMenuList();

    this.menuDepartmentControl.valueChanges
      .pipe(
        startWith(''),
        map(value => {
          //  this.isFormDirty = true;
          return this._filterMenuDepartments(value);
        })
      )
      .subscribe(filtered => this.filteredMenuDepartments = filtered);

    this.menuDepartmentControl.valueChanges.subscribe((selectedMenu: any) => {
      const selectedMenuId = typeof selectedMenu === 'object' ? selectedMenu?.id : null;

      if (!selectedMenuId) return;

      if (!this.menuInitialized) {
        // First time selection — just load, don't prompt
        this.loadNewMenu(selectedMenuId);
        this.menuInitialized = true;
        return;
      }

      if (this.isFormDirty && selectedMenuId !== this.menuId) {
        // alert('You have unsaved changes. Please save or discard them before switching menus.');
        // Prompt before switching
        const message = `You have unsaved changes. Do you want to save before switching?`;
        const dialogData = new ConfirmDialogModel("Confirm Navigation", message);

        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          maxWidth: "400px",
          data: dialogData
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            // Save first
            this.saveAndSwitch(selectedMenuId);
          } else {
            // Discard and switch
            this.loadNewMenu(selectedMenuId);
          }
        });
      } else {
        this.loadNewMenu(selectedMenuId);
      }
    });
  }

  loadNewMenu(menuId: number) {
    this.menuId = menuId;
    this.lastConfirmedMenuId = menuId;
    this.isFormDirty = false;
    this.itemClassDisplayOrderList(menuId);
  }

  saveAndSwitch(menuId: number) {
    this.save();
    // Delay the load slightly after save to ensure it's processed
    setTimeout(() => {
      this.loadNewMenu(menuId);
    }, 10);
  }


  /**
   * Dirtyness check
   * @returns 
   */
  isDirty():boolean{
    return this.isFormDirty;
  }

  getMenuList() {
    let requestData: RequestData = {
      search: {
        filters: {
          scope: {
            limit: 1000,
            offset: 0
          }
        },
        sort: [
          {
            column: "name",
            order: "asc"
          }
        ]
      }
    }
    this.itemClassDisplayOrderService.getMenuDepartmentList(requestData).subscribe({
      next: (response: any) => {
        if (response.status === 'SUCCESS') {
          this.menuList = response.data.menus;
          this.filteredMenuDepartments = this.menuList;
        } else {
          console.error('Failed to load menu departments:', response.message);
        }
      },
      error: (error: any) => {
        console.error('API error when loading menu departments:', error);
      }
    });
  }

  private _filterMenuDepartments(value: string | any): any[] {
    const filterValue = typeof value === 'string' ? value.toLowerCase() : value?.name?.toLowerCase() || '';
    return this.menuList.filter(dept => dept.name.toLowerCase().includes(filterValue));
  }

  displayMenuDepartmentName(dept: any): string {
    return dept && dept.name ? dept.name : '';
  }

  filterMenuDepartments() {
    // Optionally trigger filtering manually if needed
    this.filteredMenuDepartments = this._filterMenuDepartments(this.menuDepartmentControl.value);
  }

  clearMenuDepartment() {
    this.menuDepartmentControl.setValue('');
  }

  menuDepartmentValidator = (control: AbstractControl) => {
    const value = control.value;
    if (!value) return null; // Allow empty (optional), or change as needed
    // If value is an object (selected from autocomplete), it's valid
    if (typeof value === 'object' && value.id) return null;
    // If value is a string, check if it matches any sale item name
    const match = this.menuList.some(item => item.name.toLowerCase() === value.toLowerCase());
    return match ? null : { invalidMenuDepartment: true };
  };

  save() {
    this.itemClassForm.markAllAsTouched();
    if (this.itemClassForm.invalid) {
      // Show errors or prevent save
      return;
    }
    this.menuDepartmentControl.markAsTouched();
    if (this.menuDepartmentControl.invalid) {
      return;
    }
    const newData = this.itemSubClasses;
    let requestData = {
      itemSubClasses: newData,
      menuId: this.menuId, // Assuming menuDepartmentControl holds the selected menu object 
    }

    this.itemClassDisplayOrderService.update(requestData).subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          // handle success
          this.isFormDirty = false;
          let snckBarData: SnackBarData = {
            type: 'success',
            title: 'Saved',
            message: 'The item class display order has been updated successfully.'
          }
          this.snackBarService.openSnackBar(snckBarData);
          // this.router.navigate(['/uom']);
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      },
      error: (error) => {
        // handle error
        let snackBarData: SnackBarData = {
          message: 'Failed to update. Connection to the server failed',
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
    });
  }

  itemClassDisplayOrderList(menuId: number) {
    this.itemClassDisplayOrderService.getItemClassDisplayOrderByMenuId(menuId).subscribe({
      next: (response: any) => {
        if (response.status === 'SUCCESS') {
          this.itemSubClasses = response.data.itemSubClasses;
           const menuColor = response.data.menuColor;
          const colorOptions = [
            { name: '#7d7d7d', value: '1' },
            { name: '#942994', value: '2' },
            { name: '#37589e', value: '3' },
            { name: '#967b3c', value: '4' },
            { name: '#178217', value: '5' },
            { name: '#ad4102', value: '6' },
            { name: '#f50753', value: '7' },
            { name: '#763a91', value: '8' },
            { name: '#bf2b1b', value: '9' },
            { name: '#425e58', value: '10' },
            { name: '#993b23', value: '11' },            
          ];
          this.menuColor = colorOptions.find(color => color.value === menuColor) ;

        } else {
          console.error('Failed to load item class display order:', response.message);
        }
      },
      error: (error: any) => {
        console.error('API error when loading item class display order:', error);
      }
    });
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.itemSubClasses, event.previousIndex, event.currentIndex);
    this.isFormDirty = true;
    // console.log(this.itemSubClasses);
  }

async navBack(): Promise<void> {
  if (this.isFormDirty) {
    const message = "Are you sure you want to discard your changes? Your changes will be lost.";
    const dialogData = new ConfirmDialogModel("Discard unsaved changes?", message);
    const result = await this.confirmDialogService.openDialog(dialogData);
    if (result) {
      this.completelyReset();
    }
    // If not confirmed, do nothing
  } else {
    this.completelyReset();
  }
}

completelyReset(): void {
  this.itemClassForm.reset();
  this.menuDepartmentControl.setValue('');
  this.filteredMenuDepartments = this.menuList.slice();
  this.menuId = null;
  this.itemSubClasses = []; // <-- This clears the displayed item classes
  this.dropLists = [];
  this.menuColor = undefined;
  this.isFormDirty = false;
}
}